import React from 'react';
import { ThreeCircles } from 'react-loader-spinner';

const Spinner = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <ThreeCircles

  color="#4fa94d"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel="three-circles-rotating"
  outerCircleColor="Blue"
  innerCircleColor="Blue"
  middleCircleColor="Blue"
/>
    </div>
  );
};

export default Spinner;